var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconYoutube3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.8319 6.6503C25.8883 6.93409 26.7239 7.76973 27.0077 8.82608C27.528 10.7496 27.5438 14.7385 27.5438 14.7385C27.5438 14.7385 27.5438 18.7432 27.0235 20.651C26.7397 21.7073 25.904 22.543 24.8477 22.8268C22.9399 23.3471 15.2616 23.3471 15.2616 23.3471C15.2616 23.3471 7.58332 23.3471 5.67557 22.8268C4.61921 22.543 3.78359 21.7073 3.49979 20.651C2.97949 18.7275 2.97949 14.7385 2.97949 14.7385C2.97949 14.7385 2.97949 10.7496 3.48402 8.84185C3.76782 7.78549 4.60345 6.94987 5.6598 6.66607C7.56756 6.14577 15.2459 6.13 15.2459 6.13C15.2459 6.13 22.9242 6.13 24.8319 6.6503ZM19.1717 14.7385L12.802 18.4279V11.0492L19.1717 14.7385Z",
  fill: "white"
})));
export { SvgIconYoutube3 as ReactComponent };
export default __webpack_public_path__ + "cccf1a240ca7366a113cb56bd08440fa.svg";